import { c as _c } from "react/compiler-runtime";
import { useAlertBanner, useModalContext } from '@netpurpose/core';
import { AlertBanner as NPUIAlertBanner, type AlertBannerType as NPUIAlertBannerType } from '@netpurpose/np-ui';
import type { FC, ReactNode } from 'react';
export enum AlertBannerType {
  PendingUpload = 'pendingUpload',
  GeneralError = 'generalError',
  MutationError = 'mutationError',
  PasswordResetSuccess = 'passwordResetSuccess',
  RegisterSuccess = 'registerSuccess',
  ReportValueSuccess = 'reportValueSuccess',
  CustomError = 'customError',
}
type AlertBannerContent = Record<AlertBannerType, {
  level: NPUIAlertBannerType;
  content: ReactNode;
}>;
const alertBannerContent: AlertBannerContent = {
  [AlertBannerType.GeneralError]: {
    level: 'error',
    content: 'Something went wrong. Please try again later.'
  },
  [AlertBannerType.CustomError]: {
    level: 'error',
    content: null
  },
  [AlertBannerType.MutationError]: {
    level: 'error',
    content: 'Action could not be completed:'
  },
  [AlertBannerType.PendingUpload]: {
    level: 'loading',
    content: "We're processing your upload."
  },
  [AlertBannerType.PasswordResetSuccess]: {
    level: 'success',
    content: "Success! Your password has been changed and you're all set."
  },
  [AlertBannerType.RegisterSuccess]: {
    level: 'success',
    content: 'Success! Your registration has been completed. Welcome to the Net Purpose community.'
  },
  [AlertBannerType.ReportValueSuccess]: {
    level: 'success',
    content: 'Success! Thanks for your feedback. We will get back to you soon.'
  }
};
type Props = {
  isVisible: boolean;
  isModalOpen: boolean;
  onClose: () => void;
  type?: AlertBannerType | undefined;
  text?: ReactNode;
};
export const AlertBannerWithoutContext: FC<Props> = t0 => {
  const $ = _c(6);
  const {
    isVisible,
    type,
    isModalOpen,
    onClose,
    text
  } = t0;
  if (!isVisible || !type) {
    return null;
  }
  const {
    level,
    content
  } = alertBannerContent[type];
  const t1 = text && ` ${text}`;
  let t2;
  if ($[0] !== content || $[1] !== isModalOpen || $[2] !== level || $[3] !== onClose || $[4] !== t1) {
    t2 = <NPUIAlertBanner type={level} isOverlay={isModalOpen} onClose={onClose}>{content}{t1}</NPUIAlertBanner>;
    $[0] = content;
    $[1] = isModalOpen;
    $[2] = level;
    $[3] = onClose;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const AlertBanner: FC = () => {
  const $ = _c(9);
  const {
    isVisible,
    type,
    hideAlertBanner,
    text
  } = useAlertBanner();
  const {
    isAnyModalOpen
  } = useModalContext();
  let t0;
  if ($[0] !== hideAlertBanner || $[1] !== type) {
    t0 = () => hideAlertBanner(type);
    $[0] = hideAlertBanner;
    $[1] = type;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleClose = t0;
  let t1;
  if ($[3] !== handleClose || $[4] !== isAnyModalOpen || $[5] !== isVisible || $[6] !== text || $[7] !== type) {
    t1 = <AlertBannerWithoutContext {...{
      isVisible,
      type,
      isModalOpen: isAnyModalOpen,
      onClose: handleClose,
      text
    }} />;
    $[3] = handleClose;
    $[4] = isAnyModalOpen;
    $[5] = isVisible;
    $[6] = text;
    $[7] = type;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};